export default {
  sort: 6,
  path: '/print',
  name: 'Print',
  component: () => import('@/views/print'),
}


// WEBPACK FOOTER //
// ./src/router/modules/print.js